import * as React from "react"
import {useProductDetailsQuery} from "../../../../../hooks/useProductDetailsQuery";

export const LongDescription = () => {
    const {model: {descriptions: {long}}} = useProductDetailsQuery();

    if (!long) return <></>;

    return <div className="mb-1 long-description dont-break-out" dangerouslySetInnerHTML={{__html: long}}/>;
}